import React from 'react'
import {object, number, string} from 'yup'

import {Grid} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'
import CustomDialog from '../../components/CustomDialog'

import FormStepper from '../../components/FormStepper'
import FormikStep from '../../components/FormikStep'
import {INVALID_STATEMENT, REQUIRED_STATEMENT} from '../../constants'
import {createPreUser} from '../../services/users'

import {
    Step1,
    Step2
} from './Steps'

const styles = (theme) => ({
    home: {
        [theme.breakpoints.up('md')]: {
            marginTop: 80
        },
        marginTop: 10
    }
})

const IndividualPreRegister = ({classes}) => {
    const [open, setOpen] = React.useState(false)
    const [errorCode, setErrorCode] = React.useState(null)
    return (
        <Grid
            component="div"
            className={classes.home}
            container
            spacing={2}
            justify="center"
            alignContent="center"
            alignItems="center"
        >
            <Grid item xs={10} md={3} component="div">
                <CustomDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    errorCode={errorCode}
                    title="Não é possível realizar o cadastro"
                />
                <FormStepper
                    initialValues={{
                        name: '',
                        email: '',
                        known: ''
                    }}
                    showSteps
                    datakey="individualPreRegisterData"
                    showControls
                >
                    <FormikStep
                        validationSchema={object({
                            name: string().matches(/^([a-zA-Z]* [a-zA-Z]+)*/, INVALID_STATEMENT).required(REQUIRED_STATEMENT),
                            email: string().email(INVALID_STATEMENT).required(REQUIRED_STATEMENT),
                            known: number().required(REQUIRED_STATEMENT)
                        })}
                        submitText="Cadastrar"
                        onSubmit={async (values, helpers, step) => {
                            try {
                                await createPreUser({...values})
                                return (step + 1)
                            } catch (e) {
                                const { code } = e.response.data
                                setErrorCode(code)
                                setOpen(true)
                                return step
                            }
                        }}
                    >
                        <Step1/>
                    </FormikStep>
                    <Step2 showControls={false}/>
                </FormStepper>
            </Grid>
        </Grid>
    )
}

IndividualPreRegister.propTypes = {}

export default withStyles(styles)(IndividualPreRegister)
